function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import { NOT_FOUND } from '../utils/constants';
import BaseStorage from '../base-storage';
import LocalStorageStrategy from './local-storage';
var DELETED = '___DELETED___';

var CachedStorageStrategy = /*#__PURE__*/function (_BaseStorage) {
  _inheritsLoose(CachedStorageStrategy, _BaseStorage);

  function CachedStorageStrategy(_ref) {
    var _this;

    var remoteStrategy = _ref.remoteStrategy,
        _ref$localStrategy = _ref.localStrategy,
        localStrategy = _ref$localStrategy === void 0 ? new LocalStorageStrategy() : _ref$localStrategy;
    _this = _BaseStorage.call(this) || this;
    _this.remoteStrategy = BaseStorage.verify(remoteStrategy);
    _this.localStrategy = BaseStorage.verify(localStrategy);
    return _this;
  }

  var _proto = CachedStorageStrategy.prototype;

  _proto.extendScope = function extendScope(scope) {
    return this.remoteStrategy.extendScope(scope);
  };

  _proto._cacheItem = function _cacheItem(key, value, options) {
    return this.localStrategy.setItem(key, value, Object.assign(options, {
      expiration: 3600
    }));
  };

  _proto.setItem = function setItem(key, value, options) {
    var _this2 = this;

    return this.remoteStrategy.setItem(key, value, options).then(function () {
      return _this2._cacheItem(key, value, options);
    });
  };

  _proto.removeItem = function removeItem(key, options) {
    var _this3 = this;

    return this.remoteStrategy.removeItem(key, options).then(function () {
      return _this3._cacheItem(key, DELETED, options);
    });
  };

  _proto._getRemoteAndCache = function _getRemoteAndCache(key, options) {
    var _this4 = this;

    return this.remoteStrategy.getItem(key, options).then(function (value) {
      return _this4._cacheItem(key, value, options).then(function () {
        return value;
      });
    })["catch"](function (e) {
      if (e === NOT_FOUND) {
        return _this4._cacheItem(key, DELETED, options).then(function () {
          throw e;
        });
      }

      throw e;
    });
  };

  _proto.getItem = function getItem(key, options) {
    var _this5 = this;

    function throwIfDeletedOrReturn(value) {
      if (value === DELETED) {
        throw NOT_FOUND;
      }

      return value;
    }

    return this.localStrategy.getItem(key, options)["catch"](function () {
      return _this5._getRemoteAndCache(key, options);
    }).then(throwIfDeletedOrReturn);
  };

  _proto.getAllItems = function getAllItems(options) {
    var _this6 = this;

    return this.remoteStrategy.getAllItems(options).then(function (items) {
      return Promise.all(Object.keys(items).map(function (key) {
        return _this6._cacheItem(key, items[key], options);
      })).then(function () {
        return items;
      });
    });
  };

  return CachedStorageStrategy;
}(BaseStorage);

export { CachedStorageStrategy as default };